import { render, staticRenderFns } from "./Agentscbonly.vue?vue&type=template&id=bcc81842"
import script from "./Agentscbonly.vue?vue&type=script&lang=js"
export * from "./Agentscbonly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports